export default __webpack_public_path__ + "static/media/ic_info_error.d224a6c5.svg";